module.exports = __webpack_public_path__ + "static/media/banner3.faa977b3.jpg";